// Zustand der globalen Schnellerfassung (UX-Vorschlag P2).
//
// Eigenes Blatt-Modul (nur Signale), damit Auslöser — Hotkey N in App.tsx,
// „Erfassen" in der Befehlspalette, der mobile +-Knopf (P7) — den Dialog
// öffnen können, ohne die Dialog-Komponente selbst zu importieren.

import { signal } from "@preact/signals";

export const captureOpen = signal(false);

/** Vorbelegung des Feldes beim Öffnen (z. B. „#Projekt " vom mobilen +-Knopf). */
export const captureInitial = signal("");

/** Tag (YYYY-MM-DD), in dessen „Mein Tag" die neue Aufgabe zusätzlich
 *  eingetragen wird (P1-Einbindung aus Today.tsx); null = nicht eintragen. */
export const captureMyDay = signal<string | null>(null);

export interface OpenCaptureOptions {
  /** YYYY-MM-DD: nach dem Anlegen zusätzlich in „Mein Tag" dieses Tages. */
  myDay?: string;
}

export function openCapture(initial = "", opts: OpenCaptureOptions = {}): void {
  captureInitial.value = initial;
  captureMyDay.value = opts.myDay && /^\d{4}-\d{2}-\d{2}$/.test(opts.myDay) ? opts.myDay : null;
  captureOpen.value = true;
}

export function closeCapture(): void {
  captureOpen.value = false;
}

/** Eine in dieser Sitzung erfasste Aufgabe (nur Anzeige „Zuletzt erfasst"). */
export interface RecentCapture {
  key: string;
  title: string;
  /** „M365 · Umsetzung" bzw. Listenname. */
  where: string;
  due: string | null;
  open: () => void;
}

/** Neueste zuerst, höchstens fünf. Lebt nur bis zum Neuladen der Seite. */
export const recentCaptures = signal<RecentCapture[]>([]);

export function pushRecentCapture(item: RecentCapture): void {
  recentCaptures.value = [item, ...recentCaptures.value].slice(0, 5);
}
